 class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('.select-selected-value');
      this.btn.addEventListener('click', this.toggle.bind(this));
      this.propertie = this.querySelector('input[type="hidden"]');

      document.addEventListener( 'click', (e) => {
        const withinBoundaries = e.composedPath().includes(this);
        if ( !withinBoundaries ) this.classList.remove('active');
      });

      this.bundleSelect = this.dataset.select != '' || this.dataset.select != undefined;

      if(this.bundleSelect) {
        this.addEventListener('change', this.changeHandler.bind(this));
      }
    }
    changeHandler(e) {
      const target = e.target;
      const selectValue = target.closest('custom-select').querySelector('.select-selected-value');
      const text = e.target.closest('label').querySelector('.text span').innerText;
      const color = e.target.closest('label').querySelector('.color span').dataset.color;
      selectValue.classList.add('active');
      selectValue.querySelector('p').innerText = text;
      selectValue.querySelector('.color span').style.setProperty('--color', `${color}`);
      this.classList.remove('active');
      this.propertie.value = text;
    }
    toggle() {
      this.classList.toggle('active');
    }
  }
  customElements.define('custom-select', CustomSelect);